import React from 'react';

interface StatusIconProps {
  color?: string;        // Accept color as a prop (used for the star fill)
  strokeColor?: string;   // Accept stroke color as a prop for the circle
  width?: number;         // Accept width as a prop
  height?: number;        // Accept height as a prop
}

const StatusIcon: React.FC<StatusIconProps> = ({
  color = "#FFF",          // Default fill color for the star
  strokeColor = "#FFF",    // Default stroke color for the circle
  width = 27,              // Default width of the icon
  height = 26              // Default height of the icon
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}         // Configurable width
      height={height}       // Configurable height
      viewBox="0 0 27 26"   // Adjust the viewBox to maintain aspect ratio
      fill="none"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M6.72039 12.8585L11.5481 10.986L13.3037 5.83639C13.4867 5.29933 14.1988 5.29933 14.3819 5.83639L16.1374 10.986L20.9651 12.8585C21.4687 13.0538 21.4687 13.8134 20.9651 14.0087L16.1374 15.8812L14.3819 21.0308C14.1988 21.5679 13.4867 21.5679 13.3037 21.0308L11.5481 15.8812L6.72039 14.0087C6.2169 13.8134 6.2169 13.0538 6.72039 12.8585Z"
          fill={color} // Configurable fill color for the star
          stroke={color} // Stroke color for the star can be same as fill color
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="26" height="26" fill="white" transform="translate(26.5) rotate(90)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default StatusIcon;
